function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1948(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.5,
    height: 13.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 6.68,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.36,
    width: 21.5,
    height: 15.42,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 21.07,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28.78,
    width: 21.5,
    height: 16.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3885714285714283
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 37.14,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.5,
    width: 21.5,
    height: 17.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 54.33,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.16,
    width: 21.5,
    height: 19.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.876
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 72.85,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 82.54,
    width: 21.5,
    height: 20.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.104
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 92.80000000000001,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.07,
    width: 21.5,
    height: 21.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 113.66999999999999,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 124.27,
    width: 21.5,
    height: 21.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0714285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 135.04999999999998,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.83,
    width: 21.5,
    height: 21.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.388888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 156.805,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 167.79,
    width: 21.5,
    height: 24.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 179.79999999999998,
    fontFamily: "Arial"
  }, "\n        Gallatin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.81,
    width: 21.5,
    height: 24.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0714285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 204.135,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.46,
    width: 21.5,
    height: 27.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 230.28,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244.09,
    width: 21.5,
    height: 28.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 258.3,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 272.51,
    width: 21.5,
    height: 28.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0714285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 286.905,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 301.3,
    width: 21.5,
    height: 29.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 315.81,
    fontFamily: "Arial"
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330.32,
    width: 21.5,
    height: 29.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 344.97499999999997,
    fontFamily: "Arial"
  }, "\n        Massac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.64,
    width: 21.5,
    height: 31.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 375.175,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 390.71,
    width: 21.5,
    height: 31.28,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0714285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 406.34999999999997,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 421.99,
    width: 21.5,
    height: 32.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 438.205,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 454.41,
    width: 21.5,
    height: 33.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 471.28000000000003,
    fontFamily: "Arial"
  }, "\n        Wabash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 488.15,
    width: 21.5,
    height: 33.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 505.145,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.14,
    width: 21.5,
    height: 34.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 539.485,
    fontFamily: "Arial"
  }, "\n        Piatt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 556.83,
    width: 21.5,
    height: 35.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5833333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 574.385,
    fontFamily: "Arial"
  }, "\n        Jersey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 591.94,
    width: 21.5,
    height: 35.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 609.5600000000001,
    fontFamily: "Arial"
  }, "\n        Moultrie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.18,
    width: 21.5,
    height: 36.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 645.25,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.32,
    width: 21.5,
    height: 36.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.75,
    y: 681.6600000000001,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 0,
    width: 26.08,
    height: 30.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.54,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Bond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.58,
    y: 0,
    width: 27.68,
    height: 30.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.42,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Boone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.26,
    y: 0,
    width: 28.22,
    height: 30.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.37,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Ford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.48,
    y: 0,
    width: 28.45,
    height: 30.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.705,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.93,
    y: 0,
    width: 28.59,
    height: 30.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.225,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 0,
    width: 28.68,
    height: 30.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.097142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.86,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 0,
    width: 29.03,
    height: 30.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.71499999999997,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.23,
    y: 0,
    width: 29.48,
    height: 30.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.948
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.97,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.71,
    y: 0,
    width: 30.22,
    height: 30.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.036666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 262.82,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        DeWitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.93,
    y: 0,
    width: 31.08,
    height: 30.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.47,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.01,
    y: 0,
    width: 32.94,
    height: 30.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.368571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.48,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.95,
    y: 0,
    width: 33.4,
    height: 30.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.65,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.35,
    y: 0,
    width: 33.78,
    height: 30.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.24,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.13,
    y: 0,
    width: 33.87,
    height: 30.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.065,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 0,
    width: 34.47,
    height: 30.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.235,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Jo_Daviess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.47,
    y: 0,
    width: 36.43,
    height: 30.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.685,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.9,
    y: 0,
    width: 36.66,
    height: 30.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.23,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.56,
    y: 0,
    width: 37.17,
    height: 30.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.096666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.145,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Grundy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.73,
    y: 0,
    width: 37.31,
    height: 30.58,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.385,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Woodford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.04,
    y: 0,
    width: 37.4,
    height: 30.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.397777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.74,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 662.44,
    y: 0,
    width: 37.56,
    height: 30.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.22,
    y: 15.29,
    fontFamily: "Arial"
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 30.58,
    width: 37.02,
    height: 31.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.88875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 46.135,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 61.68,
    width: 37.02,
    height: 32.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.638888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 78.055,
    fontFamily: "Arial"
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 94.44,
    width: 37.02,
    height: 33.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.728571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 110.99,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 127.53,
    width: 37.02,
    height: 33.81,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.635000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 144.435,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 161.35,
    width: 37.02,
    height: 33.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 178.33499999999998,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 195.32,
    width: 37.02,
    height: 34.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 212.75,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 230.18,
    width: 37.02,
    height: 36.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1066666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 248.5,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 266.82,
    width: 37.02,
    height: 38.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.404000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 285.87,
    fontFamily: "Arial"
  }, "\n        Edgar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 304.92,
    width: 37.02,
    height: 38.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.288571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 324.20000000000005,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 343.48,
    width: 37.02,
    height: 40.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.404000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 363.93,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 384.38,
    width: 37.02,
    height: 41.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 404.93,
    fontFamily: "Arial"
  }, "\n        McDonough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 425.49,
    width: 37.02,
    height: 42.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.288571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 446.71500000000003,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 467.94,
    width: 37.02,
    height: 44.44,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 490.15999999999997,
    fontFamily: "Arial"
  }, "\n        Ogle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 512.38,
    width: 37.02,
    height: 44.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.340000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 534.705,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 557.03,
    width: 37.02,
    height: 45.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 579.92,
    fontFamily: "Arial"
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 602.81,
    width: 37.02,
    height: 46.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 626.0649999999999,
    fontFamily: "Arial"
  }, "\n        Iroquois\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 649.32,
    width: 37.02,
    height: 50.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.170000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.010000000000005,
    y: 674.6600000000001,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 30.58,
    width: 41.07,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.867142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.065,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.59,
    y: 30.58,
    width: 41.27,
    height: 46.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.878333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.22500000000001,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Saline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.86,
    y: 30.58,
    width: 43.5,
    height: 46.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.833333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.61,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.36,
    y: 30.58,
    width: 43.86,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.29000000000002,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.22,
    y: 30.58,
    width: 44.16,
    height: 46.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.359999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.3,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.38,
    y: 30.58,
    width: 44.98,
    height: 46.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.497999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.87,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.36,
    y: 30.58,
    width: 45,
    height: 46.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.86,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.36,
    y: 30.58,
    width: 45.48,
    height: 46.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.1,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Christian\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.83,
    y: 30.58,
    width: 45.53,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.106
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.59499999999997,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Coles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.37,
    y: 30.58,
    width: 47.3,
    height: 46.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.691666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 477.02,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Bureau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.67,
    y: 30.58,
    width: 47.8,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.691666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.57,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.47,
    y: 30.58,
    width: 48.3,
    height: 46.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.62,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Stephenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.77,
    y: 30.58,
    width: 48.97,
    height: 46.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.127777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.255,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Whiteside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.74,
    y: 30.58,
    width: 54.26,
    height: 46.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.87,
    y: 53.655,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 76.72,
    width: 57.76,
    height: 44.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.372857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 99.025,
    fontFamily: "Arial"
  }, "\n        McHenry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 121.33,
    width: 57.76,
    height: 44.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.948
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 143.7,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 166.07,
    width: 57.76,
    height: 45.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 188.89999999999998,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 211.73,
    width: 57.76,
    height: 47.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 235.47,
    fontFamily: "Arial"
  }, "\n        Macoupin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 259.22,
    width: 57.76,
    height: 53.13,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.2825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 285.785,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 312.35,
    width: 57.76,
    height: 57.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.1275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 340.86,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 369.37,
    width: 57.76,
    height: 57.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 398.33,
    fontFamily: "Arial"
  }, "\n        Kankakee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 427.29,
    width: 57.76,
    height: 62.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.552
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 458.635,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 489.98,
    width: 57.76,
    height: 67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.417777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 523.48,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 556.98,
    width: 57.76,
    height: 67.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.626666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 590.535,
    fontFamily: "Arial"
  }, "\n        McLean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.53,
    y: 624.1,
    width: 57.76,
    height: 75.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.417777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 87.41,
    y: 662.0500000000001,
    fontFamily: "Arial"
  }, "\n        Vermilion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 76.72,
    width: 64.12,
    height: 77.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.824000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.34,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.41,
    y: 76.72,
    width: 70.44,
    height: 77.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.062857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.63,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        LaSalle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.84,
    y: 76.72,
    width: 74.83,
    height: 77.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.802727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.255,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        Rock_Island\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.67,
    y: 76.72,
    width: 88.17,
    height: 77.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.755,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        Will\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.84,
    y: 76.72,
    width: 90.84,
    height: 77.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.622222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 459.26,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.68,
    y: 76.72,
    width: 96.67,
    height: 77.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.015,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        Kane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.35,
    y: 76.72,
    width: 98.65,
    height: 77.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.933333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.6750000000001,
    y: 115.52,
    fontFamily: "Arial"
  }, "\n        DuPage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 154.32,
    width: 77.51,
    height: 98.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.035,
    y: 203.79999999999998,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 253.28,
    width: 77.51,
    height: 100.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.68875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.035,
    y: 303.475,
    fontFamily: "Arial"
  }, "\n        Sangamon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 353.67,
    width: 77.51,
    height: 105.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.072857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.035,
    y: 406.27500000000003,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 458.88,
    width: 77.51,
    height: 105.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.918333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.035,
    y: 511.52,
    fontFamily: "Arial"
  }, "\n        Peoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.28,
    y: 564.15,
    width: 77.51,
    height: 135.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.612222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.035,
    y: 632.0749999999999,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.8,
    y: 154.32,
    width: 506.2,
    height: 545.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 126.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.9,
    y: 427.15999999999997,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1948);
export default __webpack_public_path__ + "static/media/1948.a7a31bc4c78cc8eea7bd5c0ab5d72ee4.svg";
export { ForwardRef as ReactComponent };